document.addEventListener('DOMContentLoaded', () => {
  
  const swiper_product_media = document.querySelectorAll('.mainvisual-swiper');
  // swiper parent
  swiper_product_media.forEach(element => {            
    const swiperSlideshow_1 = new Swiper(element, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: element.querySelector('.swiper-pagination.swiper-pagination-parent'),
        type: "progressbar"
      }
    });
  });

  const swiper_product_media_child = document.querySelectorAll('.mainvisual-swiper-child');
  swiper_product_media_child.forEach(container => { 
    const parentElementColor = container.parentElement.parentElement.querySelectorAll('.swiper-thumbnail-swatch');

    let swiperThumnail;
    parentElementColor.forEach(thumbnail => {            
      swiperThumnail = new Swiper(thumbnail, {
        loop: false,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true
      });
    });
    
    const SwiperSlideshow2 = new Swiper(container, {
      loop: false,
      slidesPerView: 1,
      allowTouchMove: false,
      effect: "fade",
      thumbs: {
        swiper: swiperThumnail,
      }
    });
  });

  // swiper child
  const swiperContainersChild = document.querySelectorAll('.mainvisual-swiper-child .child-slider');
  swiperContainersChild.forEach(child => {
    const swiperSlideshow_3 = new Swiper(child, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: child.querySelector('.swiper-pagination.swiper-pagination-child'),
        type: "progressbar"
      }
    });
  });

  if (document.querySelector('.shopify-section--main-product')) {
    const checkInterval = 1000; 
    
    function checkStatus() {
      const swiper_recommend = document.querySelectorAll('.boost-sd__recommendation .js-mainvisual-swiper');
    
      if (swiper_recommend.length > 0) {
        clearInterval(intervalId); 

        swiper_recommend.forEach(el => {            
          const swiper_recommend_1 = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
              el: el.querySelector('.swiper-pagination.swiper-pagination-parent'),
              type: "progressbar"
            }
          });
        });

        const swiper_recommend_2 = document.querySelectorAll('.boost-sd__recommendation .js-swiper-child');
        if (swiper_recommend_2.length > 0) {
          swiper_recommend_2.forEach(el1 => { 
            const parentElementColor = el1.parentElement.parentElement.parentElement.parentElement.querySelectorAll('.js-swiper-thumbnail');
            
            let SwiperThumnail;
            parentElementColor.forEach(thumbnail => {
              SwiperThumnail = new Swiper(thumbnail, {
                loop: false,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesProgress: true
              });
            });
            
            const SwiperSlideshow2 = new Swiper(container, {
              loop: false,
              slidesPerView: 1,
              allowTouchMove: false,
              effect: "fade",
              thumbs: {
                swiper: SwiperThumnail,
              }
            });
          });
        }

        // swiper child
        const swiper_recommend_3 = document.querySelectorAll('.boost-sd__recommendation .js-swiper-child .child-slider');
        if (swiper_recommend_3.length > 0) {
          swiper_recommend_3.forEach(child => {
            const SwiperSlideshow3 = new Swiper(child, {
              loop: false,
              slidesPerView: 1,
              spaceBetween: 0,
              pagination: {
                el: child.querySelector('.swiper-pagination.swiper-pagination-child'),
                type: "progressbar"
              }
            });
          });
        }
      }
    }
  
    const intervalId = setInterval(checkStatus, checkInterval);
  }

});